
























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getPrograms, deleteProgram } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import get from 'lodash/get';
import Program from '../models/Program';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import moment from 'moment';
import Datatable from '@/components/Datatable.vue';
import Boolean from '@/components/Boolean.vue';
import cloneDeep from 'lodash/cloneDeep';
import {
    formatProgramStateStatus,
    getProgramStateStatusColor,
    getStatusItems,
} from '@/data/programStateStatus';
import { fetchPromotors } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import AuthModule from '@/store/AuthModule';
import taxSystems, { getTaxSystemValue } from '@/data/taxSystems';

@Component({
    components: {
        Datatable,
        Boolean,
        FilterComponent,
    },
    filters: {
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDepartment: (value: string) => {
            if (value.startsWith('97')) {
                return value.slice(0, 3);
            }

            return value.slice(0, 2);
        },
        formatTaxSystem: (value: string[]) => {
            let state = '';
            value.forEach(el => {
                if(value.indexOf(el) !== 0) {
                    state += ', '
                }
                state += getTaxSystemValue(el);
            });
            return state;
        },
        formatProgramStateStatus,
        displayMandat: (value: number) => {
            if (typeof value == 'undefined') {
                return 'MR';
            } else {
                return value;
            }
        },
    },
})
export default class Programs extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    mandateFilter: string | undefined | null = null;
    fluxModel: string | undefined | null = null;
    statusProgramme: string | undefined | null = null;
    taxProgram: string | undefined | null = null;

    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Nom Programme',
            dataIndex: 'name',
            sorter: true,
            scopedSlots: {
                customRender: 'name',
            },
        },
        {
            title: 'Taux d\'honoraire (%)',
            dataIndex: 'duty_free_fee',
            sorter: true,
            scopedSlots: {
                customRender: 'duty_free_fee',
            },
        },
        {
            title: 'Vendeur / Promoteur',
            dataIndex: 'promoter',
            sorter: true,
            scopedSlots: {
                customRender: 'promoter',
            },
        },
        {
            title: 'N° Mandat',
            dataIndex: 'mandat.num_mandat',
            sorter: true,
            scopedSlots: {
                customRender: 'mandat',
            },
        },
        {
            title: 'Dépt.',
            dataIndex: 'address.postal_code',
            sorter: true,
            scopedSlots: {
                customRender: 'department',
            },
        },
        {
            title: 'Ville',
            dataIndex: 'address.city',
            sorter: true,
        },
        {
            title: 'Statut',
            dataIndex: 'status',
            sorter: true,
            scopedSlots: {
                customRender: 'programStateStatus',
            },
        },
        {
            title: 'Espace Partenaire',
            dataIndex: 'promoter.api_available',
            sorter: true,
            scopedSlots: {
                customRender: 'boolean',
            },
            align: 'center',
        },
        {
            title: 'Flux Connecté',
            dataIndex: 'promoter.api_connected',
            sorter: true,
            scopedSlots: {
                customRender: 'boolean',
            },
            align: 'center',
        },
        {
            title: 'Opérateur',
            dataIndex: 'updated_by',
            scopedSlots: {
                customRender: 'operator',
            },
            sorter: true,
        },
        {
            title: 'MAJ Stock',
            dataIndex: 'stock_updated_at',
            scopedSlots: {
                customRender: 'date',
            },
            sorter: true,
        },
        {
            title: 'Fiscalité',
            dataIndex: 'tax_system',
            scopedSlots: {
                customRender: 'taxSystem',
            },
            sorter: true,
        },
        {
            title: 'Création',
            dataIndex: 'created_at',
            scopedSlots: {
                customRender: 'date',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];

    promotorFilter: number | undefined = undefined;

    async fetch(meta: MetaDatatable) {
        const { data } = await getPrograms({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }

    deleteText = {
        confirm: {
            title: `Suppression du programme`,
            content: `Voulez-vous vraiment supprimer le programme ?`,
        },
        notify: {
            title: 'Programme supprimé',
            content: `Le programme a bien été supprimé`,
        },
    };

    get fetchPromotor() {
        return fetchPromotors;
    }


    get getStatus() {
        return getStatusItems('', AuthModule.roles);
    }

    get getTaxes() {
        return taxSystems;
    }

    onFilterPromotor(value: number | undefined) {
        if (value) {
            this.promotorFilter = value;
            this.meta.filters = {
                promotor: value,
            };
        } else {
            this.promotorFilter = undefined;
            this.meta.filters = {
                promotor: undefined,
            };
        }

    }

    onFilterTaxProgram(value: string) {
        if (value) {
            this.taxProgram = value;
            this.meta.filters = {
                tax_system: [value],
            };
        } else {
            this.taxProgram = undefined;
            this.meta.filters = {
                tax_system: undefined,
            };
        }
    }

    onFilterStatusProgram(value: string | undefined) {
        if (value) {
            this.statusProgramme = value;
            this.meta.filters = {
                statusProgram: value,
            };
        } else {
            this.meta.filters = {
                statusProgram: null,
            };
            this.statusProgramme = undefined;
        }
    }

    onFilterFlux(value: string | undefined) {
        if (value) {
            this.fluxModel = value;
            this.meta.filters = {
                api_connected: value,
            };
        } else {
            this.meta.filters = {
                api_connected: null,
            };
            this.fluxModel = undefined;
        }
    }

    onFilterMandate(value: string | undefined) {
        if (value) {
            this.mandateFilter = value;
            this.meta.filters = {
                mandate: value,
            };
        } else {
            this.meta.filters = {
                mandate: null,
            };
            this.mandateFilter = undefined;
        }
    }

    @Watch('meta', { deep: true })
    onMeta() {
        if (this.meta.filters) {
            if (this.meta.filters.promotor) {
                this.promotorFilter = this.meta.filters.promotor;
            }
            if (this.meta.filters.mandate) {
                this.mandateFilter = this.meta.filters.mandate;
            }
            if (this.meta.filters.api_connected) {
                this.fluxModel = this.meta.filters.api_connected;
            }
            if (this.meta.filters.mandate) {
                this.mandateFilter = this.meta.filters.mandate;
            }
            if (this.meta.filters.statusProgram) {
                this.statusProgramme = this.meta.filters.statusProgram;
            }
            if (this.meta.filters.tax_system) {
                this.taxProgram = this.meta.filters.tax_system;
            }
        }
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Program | null;
    }) {
        const action = ev.action;
        const program: Program | null = ev.item || null;
        switch (ev.action) {
            case 'show':
                if (program !== null) {
                    this.$router.push({
                        name: 'showProgram',
                        params: {
                            programID: `${program.id}`,
                        },
                    });
                }
                break;
            case 'edit':
                if (program !== null) {
                    this.$router.push({
                        name: 'editProgram',
                        params: {
                            id: `${program.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (program && program.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteProgram(program.id);
                }
                break;
        }
    }

    deleteDialog(program: Program) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(program),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    getProgramStateStatusColor(status: string) {
        return getProgramStateStatusColor(status);
    }

    created() {
        this.fluxModel = undefined;
        this.mandateFilter = undefined;
        this.promotorFilter = undefined;
        this.statusProgramme = undefined;
        this.taxProgram = undefined;
    }

    async acceptDeleteAlert(program: Program) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: program });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du programme`,
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }
}
